export const SLIGHTLY_OVERUTILIZED_THRESHOLD = 1.05
